var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "betType",
      class: {
        inRefferalStakeChanged:
          _vm.inRefferalStakeChanged && _vm.currentBetSlipState == 6
      }
    },
    [
      [
        _c("div", { staticClass: "title-parlay" }, [
          _c("span", { staticClass: "parly_first" }, [
            _vm._v(_vm._s(_vm.$t("BetSlip.tab.Standard.heading.PARLAY_FIRST")))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "teams_num" }, [
            _vm._v(_vm._s(_vm.parlayTeamsNo(_vm.bt.IDFOBetType)))
          ]),
          _vm._v(" "),
          _c("span", { key: "parly_second" }, [
            _vm._v(_vm._s(_vm.$t("BetSlip.tab.Standard.heading.PARLAY_SECOND")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bet_content" }, [
          _c("div", { staticClass: "odds_div" }, [
            _c("span", { staticClass: "price_title" }, [
              _vm._v(_vm._s(_vm.$t("BetSlip.oddsprice")))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "odds" }, [
              _vm.gettingABTnR
                ? _c("span", [_vm._v("-")])
                : _c("span", [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.formatOdds(
                            _vm.allowedBetTypesAndReturns.PotentialReturns
                              .PerBetType[_vm.bt.IDFOBetType]
                          )
                        ) +
                        "\n            "
                    )
                  ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "stake-n-return" },
            [
              _c("stake-and-return", {
                attrs: {
                  id: _vm.bt.IDFOBetType,
                  perType: "PerBetType",
                  inRefferalStakeChanged:
                    _vm.inRefferalStakeChanged && _vm.currentBetSlipState == 6,
                  stakeChange: _vm.stakeChange
                }
              })
            ],
            1
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ed939f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ed939f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslip/betTypeParlay.vue
// module id = null
// module chunks = 